import React, { useState } from 'react';
import './App.css';

import Home from './pages/Home.jsx';
import Nosotros from './pages/Nosotros.jsx';
import Flota from './pages/Flota.jsx';
import Contacto from './pages/Contacto.jsx';
import RoutePlanner from './pages/RoutePlanner.jsx';

function App() {
  const [page, setPage] = useState('home');

  function renderPage() {
    switch (page) {
      case 'flota':
        return <Flota go={setPage} />;
      case 'contacto':
        return <Contacto go={setPage} />;
      case 'route':
        return <RoutePlanner go={setPage}/>;
      case 'nosotros':
        return <Nosotros go={setPage}/>;
      case 'home':
      default:
        return <Home go={setPage} />;
    }
  }

  return (
    <div className="App">
      <header className="site-header">
        <div className="container header-inner">
          <img 
            src={`${process.env.PUBLIC_URL}/img/ChatGPT Image 22 ene 2026, 12_35_33 a.m..png`} 
            alt="Transporte Yulo Logo"
            className="brand-logo"
            onClick={() => setPage('home')}
          />
          <nav className="main-nav">
            <button onClick={() => setPage('home')} className={page === 'home' ? 'active' : ''}>Inicio</button>
            <button onClick={() => setPage('nosotros')} className={page === 'nosotros' ? 'active' : ''}>Nosotros</button>
            <button onClick={() => setPage('flota')} className={page === 'flota' ? 'active' : ''}>Flota</button>
            <button onClick={() => setPage('route')} className={page === 'route' ? 'active' : ''}>Planificador</button>
            <button onClick={() => setPage('contacto')} className={`contact-btn ${page === 'contacto' ? 'active' : ''}`}>Contactanos</button>
          </nav>
        </div>
      </header>

      <main className="container main-content">
        {renderPage()}
      </main>

      <footer className="site-footer">
        <div className="container footer-grid">
          <div className="footer-brand">
            <img
              src={`${process.env.PUBLIC_URL}/img/ChatGPT Image 22 ene 2026, 12_35_33 a.m..png`}
              alt="Transporte Yuley Camargo"
              className="footer-logo"
            />
            <p>Transporte seguro y puntual de carga urbana y nacional en toda Colombia.</p>
          </div>

          <div className="footer-col">
            <h5>Navegación</h5>
            <ul>
              <li><button onClick={() => setPage('home')}>Inicio</button></li>
              <li><button onClick={() => setPage('nosotros')}>Nosotros</button></li>
              <li><button onClick={() => setPage('flota')}>Flota</button></li>
              <li><button onClick={() => setPage('route')}>Planificador</button></li>
            </ul>
          </div>

          <div className="footer-col">
            <h5>Contacto</h5>
            <ul className="footer-contact">
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.338 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
                </svg>
                +57 313 343 2336
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M22 6c0 1-1.4 1.9-4 3.7C15.5 11.3 13.6 13 12 13s-3.5-1.7-6-3.3C3.4 7.9 2 7 2 6" />
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                </svg>
                yucamo1@hotmail.com
              </li>
              <li>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
                Bogotá, Colombia
              </li>
            </ul>
          </div>

          <div className="footer-col footer-cta">
            <h5>¿Necesitas un envío?</h5>
            <p>Escríbenos y cotizamos de una.</p>
            <button
              type="button"
              onClick={() => setPage('contacto')}
              className="footer-whatsapp"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38a9.9 9.9 0 0 0 4.74 1.21h.01c5.46 0 9.91-4.45 9.91-9.91C21.96 6.45 17.5 2 12.04 2zm0 18.14a8.2 8.2 0 0 1-4.19-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.19 8.19 0 0 1-1.26-4.37c0-4.53 3.69-8.22 8.24-8.22 2.2 0 4.27.86 5.83 2.42a8.18 8.18 0 0 1 2.41 5.82c0 4.54-3.69 8.23-8.24 8.23z" />
              </svg>
              Ir a Contacto
            </button>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container footer-bottom-inner">
            <p>© {new Date().getFullYear()} Transporte Yuley Camargo — Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;
